import React from 'react'
import IframeResizer from 'iframe-resizer-react'
import styled from '@emotion/styled'
import { Typography } from '@yanolja-org/ya-com-core'
import { CancelPolicyItemContainer } from '~/app/components/order-list/common/OrderDetailsCommonStyled'
/**
 * CancelPolicy component
 * author: soojin.oh
 */

export interface PolicyUrlInfo {
  title: string
  cancelPolicyUrl: string
}

// type definitions
type CancelPolicyProps = {
  id: string
  cancelPolicyUrl?: string
  policyUrlInfos?: PolicyUrlInfo[]
}

const WrapPolicy = styled.div`
  .title {
    ${Typography('subtitle3.multiline').bold};
    padding-left: 1rem;
    position: relative;
    top: 2rem;
  }
  .content {
    margin-bottom: 4rem;
  }
`
// CancelPolicy component
const CancelPolicy: React.FunctionComponent<CancelPolicyProps> = function ({
  id,
  cancelPolicyUrl,
  policyUrlInfos,
}) {
  if (!cancelPolicyUrl && !policyUrlInfos) {
    return null
  }

  return (
    <CancelPolicyItemContainer id={id} key={id}>
      {cancelPolicyUrl && (
        <IframeResizer src={cancelPolicyUrl} style={{ width: '100%', padding: '0 2rem' }} />
      )}
      {policyUrlInfos?.map?.(info => (
        <WrapPolicy key={info.title}>
          <div className={'title'}>{info.title}</div>
          <div className={'content'}>
            <IframeResizer
              src={info.cancelPolicyUrl}
              style={{ width: '100%', padding: '0 1rem' }}
            />
          </div>
        </WrapPolicy>
      ))}
    </CancelPolicyItemContainer>
  )
}

export default CancelPolicy
